import * as React from 'react';
import { CircularProgressProps, CircularProgress } from '@mui/material';
import styled, { keyframes } from 'styled-components';
import { omit } from 'ramda';

interface SPWCircularProgress extends Omit<CircularProgressProps, 'color'> {
  color?: string | 'primary' | 'secondary' | 'inherit';
  size?: string;
}

const rotate = keyframes`
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  `;

// Here we create a component that will rotate everything we pass in over two seconds
const Rotate = styled.div<{ $size?: string }>`
  animation: ${rotate} 1.25s linear infinite;
  height: ${({ $size }) => $size || 16}px;
  width: ${({ $size }) => $size || 16}px;
`;

export const SPWSpinner = ({
  color,
  size,
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <Rotate $size={size}>
      <SPWCircularProgress
        variant="determinate"
        value={35}
        color={color}
        size={size}
      />
    </Rotate>
  );
};

export const SPWCircularProgress = styled((props: SPWCircularProgress) => (
  <CircularProgress {...(omit(['color'], props) as CircularProgressProps)} />
))`
  && {
    color: ${(props) => (props.color ? props.color : 'white')};
    width: ${(props) => (props.size ? props.size : '16px')} !important;
    height: ${(props) => (props.size ? props.size : '16px')} !important;
  }
`;
